module.exports = __webpack_public_path__ + "static/media/emailOpenedIcon.47f8ddf7.svg";